



















// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { bookingModule } from '@/store';

@Component({
  components: {},
})
export default class extends Vue {
  get activeClass() {
    if (!bookingModule || !bookingModule.currentStep) {
      return;
    }
    return 'booking-status--' + bookingModule.currentStep;
  }

  mounted() {
    bookingModule.newBooking();
  }
}
